import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { TextField, TextFieldProps } from './TextField';

export interface FormTextFieldProps<TFieldValues extends FieldValues>
  extends Omit<
    TextFieldProps,
    'name' | 'error' | 'helperText' | 'onChange' | 'value'
  > {
  name: Path<TFieldValues>;
  control: Control<TFieldValues, unknown>;
}

export function FormTextField<TFieldValues extends FieldValues>(
  props: FormTextFieldProps<TFieldValues>
) {
  const { name, control, ...fieldProps } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          helperText={error?.message}
          error={!!error}
          onChange={onChange}
          value={value ?? ''}
          {...fieldProps}
        />
      )}
    />
  );
}
